module.exports = __webpack_public_path__ + "img/x-logo.65bbab9c.svg";